import { ITableState } from '../../base';
import { RoutePaths } from '../../routes/RoutePaths.ts';

export enum TableIds {
    JOBS = 'Jobs',
    JOB_APPLICATIONS = 'JobApplications',
    DASHBOARD_JOBS = 'DashboardJobs',
    SAVED_FOR_LATER = 'SavedForLater',
    HIRING_SOURCES = 'HiringSources',
    TEAM_MEMBERS = 'TeamMembers',
}

export const tableDataBaseUrls: Record<string, string> = {
    [TableIds.JOBS]: `${RoutePaths.jobs.slice(1)}/`,
    [TableIds.JOB_APPLICATIONS]: `${RoutePaths.jobApplications.slice(1)}/`,
    [TableIds.DASHBOARD_JOBS]: `${RoutePaths.dashboard.slice(1)}/jobs/`,
    [TableIds.SAVED_FOR_LATER]: `${RoutePaths.jobApplications.slice(1)}/?is_saved=true`,
    [TableIds.HIRING_SOURCES]: 'hiring-sources/',
    [TableIds.TEAM_MEMBERS]: 'users/',
};

export const emptyTableState = (id: string): ITableState => ({
    id: id,
    filters: {},
    sort: {},
    defaultSortKey: 'id',
    search: '',
    selectedRows: {},
    isLoading: false,
    isLoadingMore: false,
    currentPage: 1,
    totalPages: 1,
    currentEntitiesCount: 0,
    totalEntries: 0,
    initialLoad: true,
});

export const EMPTY_CELL = '---';
